<template>
	<div>
		<SOTitleBar
			:pageTitle="pageTitle"
			:type="'close'"
			:transparent="true"
			@back="back"
		/>

		<div class="vh-100 position-relative">
			<div class="camera-container" v-show="showVideo">
				<video ref="player" class="camera" autoplay playsinline/>
			</div>
			<div class="d-flex align-items-center vh-100" :class="{'hide': showVideo}" style="background: black">
				<canvas ref="canvas" class="vw-100" v-show="!showVideo"/>
			</div>
			<div class="btn-shutter" @click.prevent="shot">
				<img class="img-shutter" src="@/assets/icons/shutter.svg" alt="">
			</div>
			<div class="btn-switch" @click.prevent="switchCamera">
				<img class="img-switch-camera" src="@/assets/icons/refresh.svg" alt="">
			</div>
			<div class="p-x-20 p-y-12 bg-white d-flex-between-center align-items-center fixed-bottom">
				<div class="f-bold f-16 f-c-black">
					Anda bisa juga
				</div>
				<button class="btn btn-outline-primary" @click="openGallery">
					<img src="@/assets/icons/photo.svg" alt="" class="p-r-12">Pilih dari galeri
				</button>
				<input
					type="file"
					@change="previewFiles"
					class="hide"
					:id="'openGallery' + id"
					accept="image/png, image/gif, image/jpeg"
					multiple/>
			</div>
		</div>
	</div>
</template>

<script>
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

export default {
	name: "SOInputPhoto",
	components: {
		SOTitleBar,
	},
	props: {
		pageTitle: {
			type: String,
			default: "",
		},
		id: {
			type: String,
			default: "",
		}
	},
	mounted() {
		this.videoPlayer = this.$refs.player;
		this.canvasElement = this.$refs.canvas;
		this.streamUserMediaVideo()

		$("body").css({"overflow": "hidden"})
		$(".nav-bottom--inner").hide()
	},
	data() {
		return {
			showVideo: true,
			picture: null,
			isValid: true,
			imageBase64: "",
			imageFile: null,
			defaultCam: "rear",
		}
	},
	methods: {
		// start - fork from vue-media-recorder
		setCamera(devices, camera) {
			if (devices.length > 2) {
				const frontCamera = devices[0];
				const rearCamera = devices[devices.length - 1];

				switch (camera) {
					case "auto":
						return {deviceId: {exact: rearCamera.deviceId}};
					case "rear":
						return {deviceId: {exact: rearCamera.deviceId}};
					case "front":
						return {deviceId: {exact: frontCamera.deviceId}};
					default:
						return undefined;
				}
			} else {
				switch (camera) {
					case "auto":
						return {facingMode: {ideal: "environment"}};
					case "rear":
						return {facingMode: {exact: "environment"}};
					case "front":
						return {facingMode: {exact: "user"}};
					default:
						return undefined;
				}
			}
		},
		async streamUserMediaVideo() {
			if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
				return;
			}

			const devices = (await navigator.mediaDevices.enumerateDevices()).filter(
				({kind}) => kind === "videoinput"
			);
			const constraint = this.setCamera(devices, this.defaultCam)

			navigator.mediaDevices
				.getUserMedia({video: constraint})
				.then(stream => (this.videoPlayer.srcObject = stream))
				.catch(() => {
					this.isValid = false;
				});
		},
		async capture() {
			this.showVideo = false;
			this.canvasElement.width = this.videoPlayer.videoWidth;
			this.canvasElement.height = this.videoPlayer.videoHeight;

			var context = this.canvasElement.getContext("2d");

			context.drawImage(this.$refs.player, 0, 0);

			await this.stopVideoStream();
			this.picture = this.$refs.canvas.toDataURL();

			await fetch(this.picture)
				.then(res => res.blob())
				.then(blob => {
					this.imageFile = new File([blob], "shutter" + Date.now(), {type: "image/png"})
				})
		},
		async done() {
			this.$emit("input", this.imageFile);
			this.showVideo = true;
			// this.streamUserMediaVideo();
		},
		cancel() {
			this.showVideo = true;
			this.streamUserMediaVideo();
		},
		async stopVideoStream() {
			if (!(this.$refs.player && this.$refs.player.srcObject)) return;
			this.$refs.player.srcObject.getVideoTracks().forEach(track => {
				track.stop();
			});
		},
		// end - fork from vue-media-recorder

		async back() {
			await this.stopVideoStream();
			this.$emit("back")
		},
		async shot() {
			await this.capture()
			await this.done()
		},
		async switchCamera() {
			this.defaultCam = this.defaultCam === "rear" ? "front" : "rear"
			await this.stopVideoStream()
			await this.streamUserMediaVideo()
		},
		openGallery() {
			$("#openGallery" + this.id).click()
		},
		previewFiles(event) {
			this.imageFile = event.target.files
			this.$emit("input", this.imageFile);
		}
	},
	beforeDestroy() {
		$("body").css({"overflow": "auto"})
		$(".nav-bottom--inner").show()
		this.stopVideoStream();
	}
}
</script>

<style>
.hide {
	display: none !important;
}

.camera {
	height: 100vh !important;
	width: 100% !important;
	background: black;
}

.camera-container {
	position: absolute;
	top: 0;
}

.btn-shutter {
	height: 72px;
	width: 72px;
	background: white;
	border-radius: 50%;
	border: 1px solid #C8D0DD;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);

	position: absolute;
	bottom: 96px;
	left: 50%;
	transform: translate(-50%, -50%);
	margin: 0 auto;
}

.btn-switch {
	height: 48px;
	width: 48px;
	background: white;
	border-radius: 50%;
	border: 1px solid #C8D0DD;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);

	position: absolute;
	bottom: 118px;
	left: 70%;
	transform: translate(-50%, -50%);
	margin: 0 auto;
}

.img-shutter {
	position: absolute;
	top: 24px;
	left: 20px
}

.img-switch-camera {
	position: absolute;
	top: 14px;
	left: 14px
}
</style>